<template>
  <div class="component-body">
    <div role="alert" class="el-notification right" style="position: relative; left: 0px;">
      <div class="el-notification__group"><span class="el-notification__title">Notification</span>
        <div class="el-notification__content">
          <div>This is a message</div>
        </div>
        <div class="el-notification__closeBtn el-icon-close"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/25/Notification/index.vue